<template>
  <div class="text-animation" v-if="lang && lang !== ''">
    <span v-for="(word, index) in words" :key="index" :class="getClass(index)">
      {{ word }}
    </span>
    <div class="go-button">
      <button @click="$emit('openMenu')" type="button" class="btn btn-primary">
        {{ button[this.$route.query.lang] }} &#8594;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      words: [],
      taal: {
        nl: "Taal",
        en: "Language",
        tr: "Dil",
      },
      text: {
        nl: "Welkom bij Mado",
        en: "Welcome to Mado",
        tr: "Mado'ya Hoşgeldiniz",
      },
      button: {
        nl: "Open",
        en: "Open",
        tr: "Başla",
      },
    };
  },
  //   computed: {
  //     lang() {
  //       return (
  //         this.$route.query.lang ||
  //         new URL(location.href).searchParams.get("lang")
  //       );
  //     },
  //   },
  created() {
    this.words = this.text[this.lang].split(" ");
  },
  methods: {
    getClass(index) {
      return index % 2 === 0 ? "animated-from-left" : "animated-from-right";
    },
  },
};
</script>

<style scoped>
.text-animation {
  display: flex;
  flex-direction: column;
}

.text-animation span {
  font-size: 3rem;
}

.language-selector {
  margin-top: 50%;
  margin-bottom: 20%;
}

.go-button button {
  min-width: 120px;
  background-color: #fefefe;
  border-color: #354b7c;
  color: #354b7c;
  font-weight: bold;
  font-size: x-large;
}

.animated-from-left {
  animation: fromLeft 1.5s ease-in-out;
  font-weight: bolder;
}

.animated-from-right {
  animation: fromRight 1.5s ease-in-out;
}

@keyframes fromLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0%);
  }
}

@keyframes fromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0%);
  }
}
</style>
